
import { DirectUpload } from '@rails/activestorage'

export default class DirectUploader {
  private upload: DirectUpload
  private onProgress: any
  private onComplete: any
  private onError: any
  private meta: any

  constructor(
    file,
    {
      url = '/rails/active_storage/direct_uploads',
      onProgress = null,
      onComplete = null,
      onError = null,
      meta = null,
    },
    ) {
    this.upload = new DirectUpload(file, url, this)
    this.onProgress = onProgress || (() => {})
    this.onComplete = onComplete || (() => {})
    this.onError = onError || (() => {})
    this.meta = meta
  }

  process() {
    this.upload.create((error, blob) => {
      if (error) {
        this.onError(error, this.meta)
      } else {
        this.onComplete(blob, this.meta)
      }
    })
  }

  // Called internally by DirectUpload on `this`
  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress",
      event => this.directUploadDidProgress(event))
  }

  directUploadDidProgress(event) {
    this.onProgress(event, this.meta)
  }
}
